import React from "react";
import { formatCurrency } from "../utils/format";
import { ExpandIcon } from "./icons";
import MiniSparkline from "./MiniSparkline";

const TrendKpiCard = ({ title, value, accent, sparklineData, sparklineColor, sparklineId, onExpand }) => (
  <div className={`bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex-1 min-w-[220px] border-t-4 ${accent}`}>
    <div className="flex items-start justify-between gap-2">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{title}</p>
      <button
        onClick={onExpand}
        aria-label={`Expand ${title}`}
        className="text-slate-300 hover:text-brand-dark transition-colors shrink-0"
      >
        <ExpandIcon />
      </button>
    </div>

    <p className="text-2xl font-bold text-slate-900 mt-2">{formatCurrency(value || 0)}</p>

    {sparklineData && sparklineData.length > 1 && (
      <div className="h-10 mt-3">
        <MiniSparkline data={sparklineData} color={sparklineColor} gradientId={sparklineId} />
      </div>
    )}
  </div>
);

export default TrendKpiCard;
